// src/providers/auth/helpers.ts
var getClaims = (token) => {
  try {
    const tokenPayload = JSON.parse(atob(token.split(".")[1]));
    const namespace = "https://hasura.io/jwt/claims";
    if (tokenPayload[namespace]) {
      return tokenPayload[namespace];
    } else {
      throw new Error("No Hasura claims found in token");
    }
  } catch (err) {
    return null;
  }
};
var transformUser = (id, auth0User) => {
  if (!id || !(auth0User == null ? void 0 : auth0User.sub))
    return null;
  return {
    id,
    email: auth0User.email,
    name: auth0User.name,
    picture: auth0User.picture
  };
};

export { getClaims, transformUser };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-TVGQRSFH.mjs.map